import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: `${theme.spacing(4)} !important`,
  },
  rootActions: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(4),
  },
  paper: {
    backgroundColor: `${LIGHT_GREY} !important`,
    //padding: theme.spacing(1, 3),
    border: 'none !important'
  },
  rootContent: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3, 2),
  },
  rootImgMedia: {
    display: "flex",
    justifyContent: "center",
  },
  typographyNameCampaing:{
    flexGrow: 1, 
    textAlign: 'center', 
    fontSize: '15px !important',
    fontWeight: '500 !important',
    color: '#696969 !important'
  },
  boxID:{
    display: 'flex', 
    alignItems: 'center',
    height: '100%',  
  },
  boxOneID:{
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    height: '70px',
    paddingLeft: '10px'
  },
  boxActions:{
    display:'flex', 
    flexDirection: 'column', 
    justifyContent: 'space-evenly', 
    alignItems: 'center',
    fontSize:'15px !'
  },
  typographyIDs:{
    color: '#9C9C9C', 
    fontSize: '15px !important'
  },
  typographyID:{
    color: '#1C1C1C', 
    fontWeight: '500', 
    fontSize: '15px !important'
  },
  typographyIDPrincipal:{
    fontSize: '15px !important', 
    fontWeight: '500 !important', 
    color: '#696969 !important'
  },
  typographyComprou:{
    color: 'white',
    fontWeight: '500',
    background:'#37c84e', 
    fontSize: '12px', 
    width: 'relative',
    borderRadius: '5px',
    padding: '3px'
  },
  typographyNaoComprou:{
    color: 'white',
    fontWeight: '500',
    background:'#990100', 
    fontSize: '12px', 
    width: 'relative',
    borderRadius: '5px',
    padding: '3px'
  },
  

  imgIcon: { width: theme.spacing(4), height: theme.spacing(4) },
  imgMidia: { width: theme.spacing(20), borderRadius: theme.spacing(1) },
  cardStatus: { display: "flex", justifyContent: "center" },
}));
